import React, { useReducer, useEffect, useContext, useState } from "react";
import { Link, useNavigate, useNavigation, useParams } from "react-router-dom";
import { BreadcrumbContext } from "../../../contexts/BreadcrumbContext";
import axios from "../../../config/axios";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import { ContainerLoading } from "../../UI/loading/ContainerLoading";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import moduleConfig from "./moduleConfig";
import {
  detailsReducer,
  detailsInitialState,
} from "../../../reducers/module/detailsReducer";
import Details from "./partials/details/Details";
import { Button, Col, Dropdown, Modal, Row } from "react-bootstrap";
import useConfirm from "../../../HOC/custom/useConfirm";
import OrderStatusModal from "./partials/details/OrderStatusModal";
import { loadItemGeneral } from "../../../helpers/ModuleHelperFunctions";
import { getCurrencyCode } from "../../../helpers/CommonHelper";

const OrderView = () => {
  const { setBreadcrumb } = useContext(BreadcrumbContext);
  const [showOrderStatusModal, setShowOrderStatusModal] = useState(false);
  const [status, setStatus] = useState(0);
  const [showPrintModal2, setShowPrintModal2] = useState(false);
  const [detailsState, detailsDispatch] = useReducer(
    detailsReducer,
    detailsInitialState
  );
  const navigate = useNavigate();
  let { id } = useParams();
  const { confirm } = useConfirm();
  const loadItem = async () => {
    await loadItemGeneral(id, `${moduleConfig.url}/${id}`, detailsDispatch);
  };
  const handlePrintClick2 = (id) => {
    const modalContent = document.querySelector(".modal-content");

    const printWindow = window.open("", "", "width=800,height=600");

    // Get Bootstrap CSS from your app (if using CDN or imported in index.html)
    const bootstrapCSS = Array.from(
      document.querySelectorAll("link[rel='stylesheet']")
    )
      .map((link) => `<link rel="stylesheet" href="${link.href}">`)
      .join("");

    printWindow.document.write(`
    <html>
      <head>
        <title>Order - ${id}</title>
        ${bootstrapCSS}
        <style>
          @page { margin:5mm; }
          body {
            background: #fff;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            margin: 0;
            padding: 15px;
            font-family: Arial;
          }
          .modal-footer { display: none !important; }
           h5 { margin: 0 0 10px 0; }
          ul { padding-left: 20px; }
          li { margin-bottom: 4px; }
        </style>
      </head>
      <body>${modalContent.innerHTML}</body>
    </html>
  `);

    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
  const handleClose2 = () => setShowPrintModal2(false);
  useEffect(() => {
    loadItem();
    setBreadcrumb([
      moduleConfig.breadcrumbs.listing,
      moduleConfig.breadcrumbs.details,
    ]);
  }, [id]);

  const confirmAndAction = async (id, status) => {
    //console.log(status, status === "1" || status === 1 ? "complete" : "cancel");
    const isConfirmed = await confirm(
      `Do you really want to ${
        status === "1" || status === 1 ? "complete" : "cancel"
      } this order?`
    );

    if (isConfirmed) {
      setStatus(status);
      setShowOrderStatusModal(true);
    }
  };

  return (
    <DashboardLayout>
      {detailsState.isFetching ? (
        <ContainerLoading />
      ) : (
        <>
          {detailsState.hasError ? (
            <BlockErrorMessage error={detailsState.error} />
          ) : (
            <>
              {detailsState.data.item && (
                <>
                  <ModuleHeader
                    moduleTitle={`View ${moduleConfig.singleItemTitle}`}
                    moduleUrl={moduleConfig.url}
                  ></ModuleHeader>
                  {detailsState.data.item.orderStatus !== "2" && (
                    <div className="border mb-1 p-1 bg-light text-white rounded">
                      {(detailsState.data.item.orderStatus === "0" ||
                        detailsState.data.item.orderStatus === 0) && (
                        <Button
                          className="me-1 btn-custom-4 "
                          title={`Mark ${moduleConfig.singleItemTitle} as completed`}
                          onClick={() =>
                            confirmAndAction(detailsState.data.item._id, 1)
                          }
                        >
                          <i className="fas fa-check me-1"> </i>{" "}
                          <span className="">Complete Order</span>
                        </Button>
                      )}
                      {(detailsState.data.item.orderStatus === "0" ||
                        detailsState.data.item.orderStatus === 0) && (
                        <Button
                          className="btn-custom-3 me-1 "
                          variant="danger"
                          title={`Cancel order`}
                          onClick={() =>
                            confirmAndAction(detailsState.data.item._id, 2)
                          }
                        >
                          <i className="fas fa-times me-1"> </i>{" "}
                          <span className="">Cancel Order</span>
                        </Button>
                      )}

                      <Button
                        className="btn-custom-2 me-1 "
                        title={`Cancel order`}
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowPrintModal2(true);
                        }}
                      >
                        <i className="fas fa-download me-1"> </i>{" "}
                        <span className="">Print Order</span>
                      </Button>
                    </div>
                  )}
                  <Details
                    item={detailsState.data.item}
                    moduleConfig={moduleConfig}
                  />
                  <Modal
                    show={showPrintModal2}
                    onHide={handleClose2}
                    size="lg"
                    centered
                  >
                    <Modal.Body>
                      <div style={{ padding: "15px" }}>
                        {/* Order ID */}
                        <Row className="mb-3">
                          <Col>
                            <h3 className="fw-bold">
                             Nutricub - Order
                            </h3>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col>
                            <h6 className="">
                              Order ID -{" "}
                              <span>{detailsState.data.item?.orderId}</span>
                            </h6>
                          </Col>
                        </Row>

                        {/* To & Payment side by side */}
                        <Row className="mb-4">
                          {/* TO Section */}
                          <Col md={6}>
                            <h5 className="fw-bold mb-2">To:</h5>
                            <p className="mb-0">
                              Name:{" "}
                              {
                                detailsState.data.item?.shippingAddress
                                  ?.firstName
                              }{" "}
                              {
                                detailsState.data.item?.shippingAddress
                                  ?.lastName
                              }
                              <br />
                              Email:{" "}
                              {detailsState.data.item?.shippingAddress?.email}
                              <br />
                              Phone:{" "}
                              {detailsState.data.item?.shippingAddress?.phone}
                              <br />
                              Address:{" "}
                              {[
                                detailsState.data.item?.shippingAddress
                                  ?.addressLine1,
                                detailsState.data.item?.shippingAddress
                                  ?.addressLine2,
                                detailsState.data.item?.shippingAddress?.area,
                                detailsState.data.item?.shippingAddress
                                  ?.landmark,
                                detailsState.data.item?.shippingAddress?.city,
                                detailsState.data.item?.shippingAddress?.state,
                                detailsState.data.item?.shippingAddress
                                  ?.country,
                              ]
                                .filter(Boolean)
                                .join(", ")}
                            </p>
                          </Col>

                          {/* Payment Section */}
                          <Col md={6}>
                            <h5 className="fw-bold mb-2">Payment:</h5>
                            <p className="mb-0">
                              Total Amount:{" "}
                              <strong>
                                {detailsState.data.item?.payment?.paidAmount}{" "}
                                {getCurrencyCode()}
                              </strong>
                              <br />
                              Payment Status:{" "}
                              <span
                                className={
                                  detailsState.data.item?.payment?.status ===
                                  "1"
                                    ? "text-success fw-semibold"
                                    : "text-danger fw-semibold"
                                }
                              >
                                {detailsState.data.item?.payment?.status === "1"
                                  ? "Paid"
                                  : "Pending"}
                              </span>
                            </p>
                          </Col>
                        </Row>

                        {/* Products Section */}
                        <Row>
                          <Col>
                            <h5 className="fw-bold">Products:</h5>
                            <table className="table table-bordered align-middle">
                              <thead className="table-light">
                                <tr>
                                  <th style={{ width: "5%" }}>#</th>
                                  <th>Title</th>
                                  <th
                                    className="text-center"
                                    style={{ width: "15%" }}
                                  >
                                    Quantity
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {detailsState.data.item?.orderedItems?.map(
                                  (item, index) => (
                                    <tr key={item._id}>
                                      <td>{index + 1}</td>
                                      <td>{item.product.title}</td>
                                      <td className="text-center">
                                        {item.quantity}
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          </Col>
                        </Row>
                      </div>
                    </Modal.Body>

                    <Modal.Footer>
                      <Button variant="secondary" onClick={handleClose2}>
                        Close
                      </Button>
                      <Button
                        variant="primary"
                        onClick={() =>
                          handlePrintClick2(detailsState.data.item?.orderId)
                        }
                      >
                        Print
                      </Button>
                    </Modal.Footer>
                  </Modal>

                  <OrderStatusModal
                    show={showOrderStatusModal}
                    setShow={setShowOrderStatusModal}
                    loadItem={loadItem}
                    id={detailsState.data.item._id}
                    status={status}
                    item={detailsState.data.item}
                  />
                </>
              )}
            </>
          )}
        </>
      )}
    </DashboardLayout>
  );
};

export default OrderView;
